import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28 flex flex-col items-center text-center">
        <p className="font-heading text-6xl md:text-8xl text-primary-200 select-none">404</p>
        <h1 className="mt-4 font-heading text-xl md:text-2xl text-foreground-950">页面不存在</h1>
        <p className="mt-3 text-sm text-foreground-600 max-w-[460px]">
          你访问的地址可能已被移动或删除。可以从首页重新开始，或按分类浏览影片资料。
        </p>
        <p className="mt-2 text-xs text-foreground-400 font-label break-all">{location.pathname}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="h-10 px-5 inline-flex items-center rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap hover:bg-primary-700 transition-colors"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="h-10 px-5 inline-flex items-center rounded-md border border-background-300 text-foreground-800 text-sm whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors"
          >
            浏览分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}